import { colors, fonts } from '../../lib/theme'
import { useState } from 'react'
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'expo-router'
import { useThemeColors } from '../../lib/useThemeColors'
import GradientButton from '../GradientButton'

export default function PodioCard({ id_race, id_stage, race_name, id_stage_number, id_type_race, podioTappa, podioGc }) {
  const { t } = useTranslation()
  const router = useRouter()
  const tc = useThemeColors()
  const styles = makeStyles(tc)
  const isOneDay = Number(id_type_race) === 3
  const [tab, setTab] = useState('tappa')
  const medals = ['🥇', '🥈', '🥉']
  const podio = isOneDay ? podioTappa : (tab === 'tappa' ? podioTappa : podioGc)

  const goLeaderboard = () => router.push({
    pathname: '/leaderboard',
    params: { id_race, id_stage, scope: tab === 'gc' ? 'generale' : 'tappa' }
  })

  return (
    <View style={styles.card}>
      {/* Header */}
      <View style={styles.header}>
        <View style={{ flex: 1 }}>
          <Text style={[styles.raceName, { color: tc.text }]}>{race_name}</Text>
          <Text style={styles.stageLabel}>
            {isOneDay ? t('common.one_day_race') : `${t('common.stage')} ${id_stage_number}`}
          </Text>
        </View>
        <GradientButton onPress={goLeaderboard} size="md" style={{ flexShrink: 0, marginTop: 2 }}>{t('common.go')} </GradientButton>
      </View>

      {/* Tab */}
      <View style={styles.tabs}>
        {isOneDay ? (
          <View style={[styles.tabBtn, styles.tabBtnActive]}>
            <Text style={styles.tabTextActive}>{t('home.stage_results')}</Text>
          </View>
        ) : (
          ['tappa', 'gc'].map(k => (
            <TouchableOpacity key={k} style={[styles.tabBtn, tab === k && styles.tabBtnActive]} onPress={() => setTab(k)}>
              <Text style={[styles.tabText, tab === k && styles.tabTextActive]}>
                {k === 'tappa' ? t('home.tab_stage') : t('home.tab_gc')}
              </Text>
            </TouchableOpacity>
          ))
        )}
      </View>

      {/* Podio */}
      <View style={{ padding: 16, paddingTop: 10, paddingBottom: 14 }}>
        {!podio || podio.length === 0 ? (
          <Text style={{ color: tc.textMuted, fontSize: 13 }}>{t('home.no_data')}</Text>
        ) : (
          podio.map((p, i) => (
            <View key={i} style={styles.podioRow}>
              <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                <Text style={{ fontSize: 18 }}>{medals[p.posizione - 1] ?? `${p.posizione}°`}</Text>
                <Text style={[styles.podioName, p.posizione === 1 && styles.podioNameFirst]}>
                  {p.display_name}
                </Text>
              </View>
              <Text style={[styles.podioVal, p.posizione === 1 && styles.podioValFirst]}>
                {p.valore}
              </Text>
            </View>
          ))
        )}
      </View>
    </View>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  card: { borderRadius: 14, borderWidth: 1, backgroundColor: tc.bgCard, borderColor: tc.rosaBorder, overflow: 'hidden' },
  header: { flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', padding: 16, paddingBottom: 10, gap: 10 },
  raceName: { fontSize: 18, fontFamily: fonts.condensedBold, textTransform: 'uppercase', lineHeight: 20 },
  stageLabel: { fontSize: 11, fontFamily: fonts.condensedBold, color: tc.text, textTransform: 'uppercase', marginTop: 2, opacity: 0.6 },
  goBtn: { backgroundColor: tc.rosa, borderRadius: 8, paddingHorizontal: 24, paddingVertical: 9, flexShrink: 0 },
  goBtnText: { color: tc.brandText, fontFamily: fonts.condensedBold, fontSize: 14 },
  
  // MODIFICATO PER LOOK PWA
  tabs: { flexDirection: 'row', backgroundColor: tc.bgCard2, marginHorizontal: 16, borderRadius: 8, padding: 3 },
  tabBtn: { flex: 1, paddingVertical: 6, alignItems: 'center', justifyContent: 'center', borderRadius: 6 },
  
  tabBtnActive: { backgroundColor: tc.rosa },
  tabText: { fontSize: 12, fontFamily: fonts.condensedBold, color: tc.textMuted, textTransform: 'uppercase', letterSpacing: 1 },
  tabTextActive: { color: tc.brandText, fontFamily: fonts.condensedBold, fontSize: 12, textTransform: 'uppercase', letterSpacing: 1 },
  podioRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 8, borderBottomWidth: 1, borderBottomColor: tc.border },
  podioName: { fontSize: 14, color: tc.textMuted, fontWeight: '400' },
  podioNameFirst: { fontSize: 14, color: tc.text, fontWeight: '700' },
  podioVal: { fontSize: 13, fontFamily: fonts.condensedBold, color: tc.textDim, letterSpacing: 0.5 },
  podioValFirst: { fontSize: 13, fontFamily: fonts.condensedBold, color: tc.rosaText, letterSpacing: 0.5 },
})